import { SearchProps } from './interface'

export function detectMessage(error?: boolean, resultMessage?: SearchProps['resultMessage']) {
  if (error) {
    return resultMessage?.error || 'FAQの取得に失敗しました'
  }
  return resultMessage?.success || '該当はありません'
}
